import { render, staticRenderFns } from "./DisplayOptions.vue?vue&type=template&id=3b31e769&scoped=true&"
import script from "./DisplayOptions.vue?vue&type=script&lang=js&"
export * from "./DisplayOptions.vue?vue&type=script&lang=js&"
import style0 from "./DisplayOptions.vue?vue&type=style&index=0&id=3b31e769&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b31e769",
  null
  
)

export default component.exports